import { render } from "./puzzle.vue.js?vue&type=template&id=3b4de82a!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./puzzle.vue?vue&type=template&id=3b4de82a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__